/* lg-reviews — レビュー投稿フォーム。
 *
 * URL: /pages/review?t=<64hex>   （t はレビュー依頼メールのリンクに入る投稿トークン）
 *
 * 表示できるのは「この注文で買った商品」だけ。一覧は Worker が token を認可として返す。
 * 本文の描画は textContent のみ（innerHTML を使わない＝入力がそのまま HTML にならない）。
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-lg-reviews]');
  if (!root) return;

  var API = root.getAttribute('data-api');
  var TOKEN_RE = /^[0-9a-f]{64}$/;

  var el = {
    form: root.querySelector('[data-rv-form]'),
    intro: root.querySelector('[data-rv-intro]'),
    items: root.querySelector('[data-rv-items]'),
    itemList: root.querySelector('[data-rv-item-list]'),
    selected: root.querySelector('[data-rv-selected]'),
    selectedThumb: root.querySelector('[data-rv-selected-thumb]'),
    selectedName: root.querySelector('[data-rv-selected-name]'),
    selectedVariant: root.querySelector('[data-rv-selected-variant]'),
    body: root.querySelector('[data-rv-body]'),
    count: root.querySelector('[data-rv-count]'),
    submit: root.querySelector('[data-rv-submit]'),
    msg: root.querySelector('[data-rv-msg]'),
  };
  var itemsBySku = {};

  function token() {
    var t = new URLSearchParams(location.search).get('t') || '';
    return TOKEN_RE.test(t) ? t : '';
  }

  function say(text, isError) {
    el.msg.textContent = text;
    el.msg.classList.toggle('lg-rv__msg--error', !!isError);
    el.msg.hidden = false;
  }

  function show(node, on) {
    node.hidden = !on;
  }

  // ── 入力できる商品の一覧 ──────────────────────────────
  function renderItems(items) {
    el.itemList.textContent = '';
    itemsBySku = {};
    var selectable = 0;
    var firstSelectable = null;

    items.forEach(function (it) {
      itemsBySku[it.review_sku] = it;
      var done = !!it.submitted;
      var label = document.createElement('label');
      label.className = 'lg-rv__item' + (done ? ' lg-rv__item--done' : '');

      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'review_sku';
      radio.value = it.review_sku;
      radio.disabled = done;
      if (!done && selectable === 0) {
        radio.checked = true;
        firstSelectable = it.review_sku;
      }
      if (!done) selectable++;

      // 画像は Shopify CDN の URL のみ（Worker が sku_products から返す）。
      // 無ければ枠だけのプレースホルダにして崩れないようにする
      if (it.image_url) {
        var thumb = document.createElement('img');
        thumb.className = 'lg-rv__item-thumb';
        thumb.src = it.image_url;
        thumb.alt = '';
        thumb.loading = 'lazy';
        label.appendChild(thumb);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'lg-rv__item-thumb';
        label.appendChild(placeholder);
      }

      var box = document.createElement('span');
      var name = document.createElement('span');
      name.className = 'lg-rv__item-name';
      name.textContent = it.title || it.review_sku;
      var sub = document.createElement('span');
      sub.className = 'lg-rv__item-sub';
      sub.textContent = done
        ? 'この商品はレビュー投稿済みです'
        : (it.variant_label || '');

      box.appendChild(name);
      if (sub.textContent) {
        box.appendChild(document.createElement('br'));
        box.appendChild(sub);
      }
      label.appendChild(radio);
      label.appendChild(box);
      el.itemList.appendChild(label);
    });

    // 1件しか選べないなら選択肢としては出さないが、何を書くのかは見せる
    show(el.items, items.length > 0);
    // 「今どれを書いているか」の再確認パネルは、選べる商品が2つ以上ある時だけ出す。
    // 選択肢が1つしか無ければ、その1枚の商品カードと内容が完全に重複するだけになる
    onlyOneChoice = selectable <= 1;
    updateSelectedPreview(firstSelectable);
    return selectable;
  }

  var onlyOneChoice = true;

  // ── 今どの商品にレビューを書いているかのプレビュー ─────────
  function updateSelectedPreview(sku) {
    if (!el.selected) return;
    var it = (sku && !onlyOneChoice) ? itemsBySku[sku] : null;
    if (!it) {
      show(el.selected, false);
      return;
    }
    el.selectedName.textContent = it.title || it.review_sku;
    el.selectedVariant.textContent = it.variant_label || '';
    el.selectedVariant.hidden = !it.variant_label;
    if (it.image_url) {
      el.selectedThumb.src = it.image_url;
      el.selectedThumb.hidden = false;
    } else {
      el.selectedThumb.removeAttribute('src');
      el.selectedThumb.hidden = true;
    }
    show(el.selected, true);
  }

  if (el.itemList) {
    el.itemList.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'review_sku') {
        updateSelectedPreview(e.target.value);
      }
    });
  }

  function start() {
    var t = token();
    if (!t) {
      show(el.intro, true);
      show(el.form, false);
      return;
    }

    fetch(API + '/api/reviews/items?invite=' + encodeURIComponent(t), { method: 'GET' })
      .then(function (r) {
        return r.json().then(function (j) {
          return { ok: r.ok, json: j };
        });
      })
      .then(function (res) {
        if (!res.ok || !res.json.success) {
          show(el.intro, true);
          show(el.form, false);
          say('このリンクは有効期限が切れているか、すでに使えなくなっています。お手数ですが最新のメールのリンクをお試しください。', true);
          return;
        }
        var items = res.json.items || [];
        if (!items.length) {
          show(el.intro, true);
          show(el.form, false);
          say('このご注文にレビュー対象の商品が見つかりませんでした。', true);
          return;
        }
        show(el.intro, false);
        show(el.form, true);
        if (renderItems(items) === 0) {
          say('ご注文いただいた商品はすべてレビュー投稿済みです。ありがとうございます。', false);
          el.submit.setAttribute('aria-disabled', 'true');
        }
      })
      .catch(function () {
        show(el.intro, true);
        show(el.form, false);
        say('通信に失敗しました。時間をおいて再度お試しください。', true);
      });
  }

  if (el.body && el.count) {
    var updateCount = function () {
      el.count.textContent = el.body.value.length + ' / 2000';
    };
    el.body.addEventListener('input', updateCount);
    updateCount();
  }

  el.form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (el.submit.getAttribute('aria-disabled') === 'true') return;

    var fd = new FormData(el.form);
    var payload = {
      invite: token(),
      review_sku: fd.get('review_sku') || '',
      rating: Number(fd.get('rating') || 0),
      title: fd.get('title') || '',
      body: fd.get('body') || '',
      author_name: fd.get('author_name') || '',
      website: fd.get('website') || '', // honeypot
    };

    if (!payload.review_sku) return say('商品を選んでください。', true);
    if (!payload.rating) return say('評価（星）を選んでください。', true);
    if (payload.body.trim().length < 10) return say('本文を10文字以上ご入力ください。', true);

    el.submit.setAttribute('aria-disabled', 'true');
    el.msg.hidden = true;

    fetch(API + '/api/reviews/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json().then(function (j) {
          return { status: r.status, json: j };
        });
      })
      .then(function (res) {
        if (res.status === 200 && res.json.success) {
          show(el.form, false);
          say('ありがとうございました。内容を確認のうえ掲載いたします（数日いただく場合があります）。', false);
          return;
        }
        el.submit.removeAttribute('aria-disabled');
        if (res.status === 409) return say('この商品のレビューはすでに投稿いただいています。ありがとうございます。', true);
        if (res.status === 429) return say('しばらく時間をおいてからお試しください。', true);
        if (res.status === 503) return say('ただいまレビューの受付を停止しています。', true);
        say('送信できませんでした。入力内容をご確認のうえ、もう一度お試しください。', true);
      })
      .catch(function () {
        el.submit.removeAttribute('aria-disabled');
        say('通信に失敗しました。時間をおいて再度お試しください。', true);
      });
  });

  start();
})();
